import { gql } from 'apollo-boost';

export const SUBSCRIBE_TO_ORDERS = gql`
    subscription {
        Shipments(order_by: { is_expedited: desc, updated_at: asc }) {
            is_expedited
            num_of_gophrs
            shipment_friendly_id
            created_by
            cust_auth0_id
            customer_blob
            distance
            shipment_total
            contains_alcohol
            shipping_fee
            sum_of_orders_total
            weight
            created_at
            shipment_id
            updated_at
            description
            drop_off_instructions
            pick_up_instructions
            scheduled_for
            shipment_type
            status
            billing_status
            vehicle_type
            is_roundtrip
            merchant_order_id
            shipping_fee_blob
            placed_by
            completed_at
            fedex_data
            ai_recommendation
            billing_details
            is_ship_tomorrow
            Orders(order_by: { order_friendly_id: asc }) {
                order_id
                shipment_id
                store_id
                location_blob
                order_friendly_id
                actions
                status
                subtotal
                sum_tax
                total
                created_at
                updated_at
                pick_up_instructions
                description
                weight
                drop_off_instructions
                estimated_arrival_time
                arrived_at
                completed_at
                photos
                actual_action
                OrderHandshakes(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
                    name
                    type
                    url
                }
                Items {
                    item_id
                    product_blob
                    quantity
                    product_price
                    status
                    product_id
                    ItemOptions {
                        option_name
                        option_price
                        variant_name
                        variant_blob
                        option_blob
                    }
                    Order {
                        order_id
                        contains_alcohol
                        Shipment {
                            shipment_id
                        }
                    }
                }
            }
            LocationUpdates(order_by: { timestamp: asc }) {
                latitude
                longitude
                timestamp
            }
            Route {
                RouteDrivers(where: { status: { _eq: "driver" }, deleted_at: { _is_null: true } }) {
                    created_at
                    driver_blob
                    driver_id
                    vehicle_blob
                    tracking_blob
                }
            }
            ShipmentHandshakes {
                url
                type
            }
        }
    }
`;

export const SUBSCRIBE_TO_SHIPMENTS = gql`
    subscription($market_id: [String!], $demurrage_review_since: timestamptz!) {
        Shipments(
            order_by: { is_expedited: desc, updated_at: asc }
            where: {
                market_id: { _in: $market_id }
                deleted_at: { _is_null: true }
                status: { _in: ["shipment_created", "shipment_scheduled", "shipment_saved", "shipment_pending_saved", "shipment_pending", "shipment_pending_schedule", "shipment_pending_payment", "shipment_saved_pending_payment_retry"] }
            }
        ) {
            created_at
            cust_auth0_id
            customer_blob
            description
            contains_alcohol
            distance
            drop_off_instructions
            gratuity
            is_expedited
            market_id
            num_of_gophrs
            pick_up_instructions
            scheduled_for
            shipment_friendly_id
            shipment_id
            shipment_total
            shipment_type
            shipping_fee
            status
            sum_of_orders_total
            updated_at
            vehicle_type
            weight
            completed_at
            merchant_order_id
            shipping_fee_blob
            placed_by
            fedex_data
            ai_recommendation
            client_type
            billing_details
            is_ship_tomorrow
            Orders(order_by: { order_friendly_id: asc }) {
                order_id
                actions
                location_blob
                order_friendly_id
                status
                subtotal
                sum_tax
                total
                created_at
                updated_at
                pick_up_instructions
                description
                weight
                drop_off_instructions
                estimated_arrival_time
                completed_at
                actual_action
                OrderHandshakes(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
                    name
                    type
                    url
                }
                Items {
                    item_id
                    product_blob
                    quantity
                    product_price
                    status
                    product_id
                    ItemOptions {
                        option_name
                        option_price
                        variant_name
                        variant_blob
                        option_blob
                    }
                }
            }
            Route {
                route_id
                route_friendly_id
                path
                bounds
                RouteDrivers {
                    distance
                    driver_auth0_id
                    driver_blob
                    vehicle_id
                    vehicle_blob
                    status
                }
            }
        }
        DemurrageReviewShipments: Shipments(
            order_by: { updated_at: desc }
            where: {
                market_id: { _in: $market_id }
                deleted_at: { _is_null: true }
                completed_at: { _gte: $demurrage_review_since }
                billing_details: { _contains: { demurrage: { approval: { status: "pending" } } } }
            }
        ) {
            shipment_friendly_id
            shipment_id
            status
            vehicle_type
            billing_details
            shipping_fee_blob
            Orders(order_by: { order_friendly_id: asc }) {
                order_id
                order_friendly_id
                actual_action
                location_blob
            }
        }
    }
`;

export const GET_DISPATCH_SHIPMENTS = {
    ...SUBSCRIBE_TO_SHIPMENTS,
    definitions: SUBSCRIBE_TO_SHIPMENTS.definitions.map(definition =>
        definition.kind === 'OperationDefinition'
            ? { ...definition, operation: 'query' }
            : definition
    ),
};

export const SUBSCRIBE_TO_ROUTES = gql`
    subscription($market_id: [String!]) {
        Routes(
            order_by: { is_expedited: desc, updated_at: asc }
            where: {
                _and: [
                    {
                        _or: [
                            { market_id: { _in: $market_id } }
                            { Shipments: { market_id: { _in: $market_id } } }
                        ]
                    }
                    { deleted_at: { _is_null: true } }
                    {
                        status: {
                            _in: [
                                "route_ready"
                                "route_claimed"
                                "route_assigned"
                                "route_enroute"
                                "route_temp_claimed"
                                "route_temp_claimed_dispatch"
                                "route_saved_pending_payment_retry"
                            ]
                        }
                    }
                ]
            }
        ) {
            bounds
            path
            driven_route
            contains_alcohol
            created_at
            updated_at
            completed_at
            market_id
            num_of_gophrs
            distance
            route_id
            route_friendly_id
            status
            waypoints_number
            is_expedited
            short_code
            RouteDrivers(where: { deleted_at: { _is_null: true } }, order_by: { created_at: asc }) {
                created_at
                driver_blob
                distance
                driver_auth0_id
                vehicle_id
                vehicle_blob
                status
                driver_id
                employment_type
                tracking_blob
            }
            LocationUpdates(order_by: { timestamp: asc }) {
                latitude
                longitude
                timestamp
            }
            Shipments {
                shipment_id
                route_id
                shipment_friendly_id
                shipment_type
                cust_auth0_id
                customer_blob
                description
                drop_off_instructions
                status
                distance
                shipping_fee
                weight
                is_expedited
                vehicle_type
                num_of_gophrs
                created_at
                updated_at
                pick_up_instructions
                scheduled_for
                contains_alcohol
                merchant_order_id
                shipping_fee_blob
                placed_by
                fedex_data
                ai_recommendation
                client_type
                billing_details
                is_ship_tomorrow
                DriverPays {
                    total_earning
                    driver_status
                    deleted_at
                }
                Orders(order_by: { order_friendly_id: asc }) {
                    shipment_id
                    order_id
                    store_id
                    location_blob
                    contains_alcohol
                    order_friendly_id
                    status
                    subtotal
                    sum_tax
                    total
                    created_at
                    updated_at
                    pick_up_instructions
                    description
                    weight
                    drop_off_instructions
                    actions
                    estimated_arrival_time
                    completed_at
                    photos
                    actual_action
                    OrderHandshakes(where: { deleted_at: { _is_null: true } }, order_by: { created_at: desc }) {
                        name
                        type
                        url
                    }
                    Items {
                        item_id
                        product_blob
                        quantity
                        product_price
                        status
                        product_id
                        ItemOptions {
                            option_name
                            option_price
                            variant_name
                            variant_blob
                            option_blob
                        }
                    }
                }
                ShipmentHandshakes {
                    url
                    type
                }
            }
        }
    }
`;

export const GET_DISPATCH_ROUTE_LIST = gql`
    query($market_id: [String!]) {
        Routes(
            order_by: { is_expedited: desc, updated_at: asc }
            where: {
                _and: [
                    {
                        _or: [
                            { market_id: { _in: $market_id } }
                            { Shipments: { market_id: { _in: $market_id } } }
                        ]
                    }
                    { deleted_at: { _is_null: true } }
                    {
                        status: {
                            _in: [
                                "route_ready"
                                "route_claimed"
                                "route_assigned"
                                "route_enroute"
                                "route_temp_claimed"
                                "route_temp_claimed_dispatch"
                                "route_saved_pending_payment_retry"
                            ]
                        }
                    }
                ]
            }
        ) {
            bounds
            path
            driven_route
            contains_alcohol
            created_at
            updated_at
            completed_at
            market_id
            route_id
            route_friendly_id
            status
            is_expedited
            short_code
            RouteDrivers(where: { deleted_at: { _is_null: true } }, order_by: { created_at: asc }) {
                created_at
                driver_blob
                driver_auth0_id
                vehicle_id
                vehicle_blob
                status
                driver_id
                employment_type
                tracking_blob
            }
            LocationUpdates(order_by: { timestamp: asc }) {
                latitude
                longitude
                timestamp
            }
            Shipments(order_by: { shipment_friendly_id: asc }) {
                shipment_id
                route_id
                market_id
                shipment_friendly_id
                shipment_type
                customer_blob
                description
                drop_off_instructions
                status
                distance
                shipping_fee
                weight
                num_of_gophrs
                is_expedited
                vehicle_type
                contains_alcohol
                created_at
                updated_at
                pick_up_instructions
                scheduled_for
                shipping_fee_blob
                billing_details
                placed_by
                fedex_data
                ai_recommendation
                client_type
                is_ship_tomorrow
                DriverPays {
                    total_earning
                    driver_status
                    deleted_at
                }
                Orders(order_by: { order_friendly_id: asc }) {
                    shipment_id
                    order_id
                    store_id
                    order_friendly_id
                    status
                    location_blob
                    actions
                    actual_action
                    pick_up_instructions
                    drop_off_instructions
                    estimated_arrival_time
                    arrived_at
                    completed_at
                    updated_at
                }
            }
        }
    }
`;

export const GET_DISPATCH_COMPLETED_ROUTE_PAGE = gql`
    query($market_id: [String!], $limit: Int, $offset: Int) {
        Routes(
            order_by: { completed_at: desc, updated_at: desc }
            limit: $limit
            offset: $offset
            where: {
                _and: [
                    {
                        _or: [
                            { market_id: { _in: $market_id } }
                            { Shipments: { market_id: { _in: $market_id } } }
                        ]
                    }
                    { deleted_at: { _is_null: true } }
                    { status: { _eq: "route_completed" } }
                ]
            }
        ) {
            bounds
            path
            driven_route
            contains_alcohol
            created_at
            updated_at
            completed_at
            market_id
            route_id
            route_friendly_id
            status
            is_expedited
            short_code
            RouteDrivers(where: { deleted_at: { _is_null: true } }, order_by: { created_at: asc }) {
                created_at
                driver_blob
                driver_auth0_id
                vehicle_id
                vehicle_blob
                status
                driver_id
                employment_type
                tracking_blob
            }
            LocationUpdates(order_by: { timestamp: asc }) {
                latitude
                longitude
                timestamp
            }
            Shipments(order_by: { shipment_friendly_id: asc }) {
                shipment_id
                route_id
                market_id
                shipment_friendly_id
                shipment_type
                customer_blob
                description
                drop_off_instructions
                status
                distance
                shipping_fee
                weight
                num_of_gophrs
                is_expedited
                vehicle_type
                contains_alcohol
                created_at
                updated_at
                pick_up_instructions
                scheduled_for
                shipping_fee_blob
                billing_details
                placed_by
                fedex_data
                ai_recommendation
                client_type
                is_ship_tomorrow
                DriverPays {
                    total_earning
                    driver_status
                    deleted_at
                }
                Orders(order_by: { order_friendly_id: asc }) {
                    shipment_id
                    order_id
                    location_blob
                    contains_alcohol
                    order_friendly_id
                    status
                    created_at
                    updated_at
                    pick_up_instructions
                    description
                    weight
                    drop_off_instructions
                    actions
                    estimated_arrival_time
                    completed_at
                    actual_action
                }
                ShipmentHandshakes {
                    url
                    type
                }
            }
        }
    }
`;

export const GET_DISPATCH_MONTHLY_METRICS = gql`
    query($market_id: [String!], $month_start: timestamptz!, $month_end: timestamptz!) {
        Shipments(
            where: {
                _and: [
                    { market_id: { _in: $market_id } }
                    { deleted_at: { _is_null: true } }
                    { status: { _eq: "shipment_completed" } }
                    { description: { _nilike: "%Test%" } }
                    {
                        _or: [
                            {
                                _and: [
                                    { completed_at: { _is_null: false } }
                                    { completed_at: { _gte: $month_start } }
                                    { completed_at: { _lt: $month_end } }
                                ]
                            }
                            {
                                _and: [
                                    { completed_at: { _is_null: true } }
                                    { updated_at: { _gte: $month_start } }
                                    { updated_at: { _lt: $month_end } }
                                ]
                            }
                        ]
                    }
                ]
            }
            order_by: { completed_at: desc }
        ) {
            shipment_id
            created_at
            completed_at
            updated_at
            scheduled_for
            is_expedited
            shipping_fee
            driver_1099_earning
            cust_auth0_id
            customer_blob
            Orders(order_by: { order_friendly_id: asc }) {
                order_id
                created_at
                updated_at
                completed_at
                arrived_at
                estimated_arrival_time
                actual_action
                actions
            }
        }
        Routes(
            where: {
                _and: [
                    {
                        _or: [
                            { market_id: { _in: $market_id } }
                            { Shipments: { market_id: { _in: $market_id } } }
                        ]
                    }
                    { deleted_at: { _is_null: true } }
                    { status: { _eq: "route_completed" } }
                    { completed_at: { _gte: $month_start } }
                    { completed_at: { _lt: $month_end } }
                ]
            }
            order_by: { completed_at: desc }
        ) {
            route_id
            created_at
            path
            Shipments(order_by: { shipment_friendly_id: asc }) {
                shipment_id
                created_at
                completed_at
                updated_at
                scheduled_for
                is_expedited
                shipping_fee
                driver_1099_earning
                cust_auth0_id
                customer_blob
                Orders(order_by: { order_friendly_id: asc }) {
                    order_id
                    created_at
                    updated_at
                    completed_at
                    arrived_at
                    estimated_arrival_time
                    actual_action
                    actions
                }
            }
        }
    }
`;
